/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputUavCrewMember } from './OutputUavCrewMember';
import {
    OutputUavCrewMemberFromJSON,
    OutputUavCrewMemberFromJSONTyped,
    OutputUavCrewMemberToJSON,
} from './OutputUavCrewMember';
import type { OutputUavCrewSettings } from './OutputUavCrewSettings';
import {
    OutputUavCrewSettingsFromJSON,
    OutputUavCrewSettingsFromJSONTyped,
    OutputUavCrewSettingsToJSON,
} from './OutputUavCrewSettings';

/**
 * 
 * @export
 * @interface OutputUavCrewContext
 */
export interface OutputUavCrewContext {
    /**
     * CrewRole — роль користувача в екіпажі (commander|pilot|operator|member). Прав не ріже,
     * використовується для підстановки пілота за замовчуванням.
     * @type {string}
     * @memberof OutputUavCrewContext
     */
    crewRole?: string;
    /**
     * DivisionID/DivisionName — підрозділ екіпажу (він же підрозділ заявок, а не підрозділ
     * з профілю користувача).
     * @type {number}
     * @memberof OutputUavCrewContext
     */
    divisionId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewContext
     */
    divisionName?: string;
    /**
     * Members — склад екіпажу: у формі з нього обирають пілота цього вильоту.
     * @type {Array<OutputUavCrewMember>}
     * @memberof OutputUavCrewContext
     */
    members?: Array<OutputUavCrewMember>;
    /**
     * Settings — сталі параметри вильоту. null = екіпаж їх ще не заповнював.
     * @type {OutputUavCrewSettings}
     * @memberof OutputUavCrewContext
     */
    settings?: OutputUavCrewSettings;
    /**
     * TeamID/TeamName — рідний екіпаж користувача. null = юзера ще не додали до складу або
     * командир не активував екіпаж; сторінка тоді показує пояснення замість форми.
     * @type {number}
     * @memberof OutputUavCrewContext
     */
    teamId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewContext
     */
    teamName?: string;
}

/**
 * Check if a given object implements the OutputUavCrewContext interface.
 */
export function instanceOfOutputUavCrewContext(value: object): boolean {
    return true;
}

export function OutputUavCrewContextFromJSON(json: any): OutputUavCrewContext {
    return OutputUavCrewContextFromJSONTyped(json, false);
}

export function OutputUavCrewContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavCrewContext {
    if (json == null) {
        return json;
    }
    return {
        
        'crewRole': json['crewRole'] == null ? undefined : json['crewRole'],
        'divisionId': json['divisionId'] == null ? undefined : json['divisionId'],
        'divisionName': json['divisionName'] == null ? undefined : json['divisionName'],
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(OutputUavCrewMemberFromJSON)),
        'settings': json['settings'] == null ? undefined : OutputUavCrewSettingsFromJSON(json['settings']),
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
    };
}

export function OutputUavCrewContextToJSON(value?: OutputUavCrewContext | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'crewRole': value['crewRole'],
        'divisionId': value['divisionId'],
        'divisionName': value['divisionName'],
        'members': value['members'] == null ? undefined : ((value['members'] as Array<any>).map(OutputUavCrewMemberToJSON)),
        'settings': OutputUavCrewSettingsToJSON(value['settings']),
        'teamId': value['teamId'],
        'teamName': value['teamName'],
    };
}

